import React from 'react';
import FinancialReportsPanel from './FinancialReportsPanel';

const IncomeReportsPanel: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <FinancialReportsPanel module="income" onBack={onBack} />
);

export default IncomeReportsPanel;
